import * as React from 'react';
import { rem } from 'polished';

import { styled } from './themeContext';
import { ReactComponent as SideDecoSvg } from './sectionDeco/sideDeco.svg';
import centerDecoUrl from './sectionDeco/centerDeco.png';

type SectionDecoProps = {
  decoColor?: string,
};

type sideDecoProps = {
  color?: string,
};

const Container = styled.div(props => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  height: 0,
  zIndex: 1,
  boxSizing: 'border-box',
  padding: `0 ${rem(7)}`,
  [props.theme.media['lg']]: {
    padding: `0 ${rem(20)}`,
  },
  [props.theme.media['lg']]: {
    width: '100%',
    maxWidth: rem(1200),
    margin: '0 auto',
  },
}));

const SideDeco = styled(SideDecoSvg)<sideDecoProps>(props => ({
  'width': rem(90),
  'height': rem(40),
  'marginTop': rem(7),
  '&.right': {
    transform: 'matrix(-1, 0, 0, 1, 0, 0)',
  },
  'fill': props.color ? props.color : '#061648',
  [props.theme.media['md']]: {
    width: rem(178),
    height: rem(78),
    marginTop: rem(10),
  },
}));

const CenterDeco = styled.img(props => ({
  width: rem(35),
  height: rem(20),
  [props.theme.media['md']]: {
    width: rem(70),
    height: rem(40),
  },
}));

const SectionDeco: React.FC<SectionDecoProps> = ({
  decoColor,
}) => {
  return (
    <Container>
      <SideDeco className='left' color={decoColor} />
      <CenterDeco src={centerDecoUrl} />
      <SideDeco className='right' color={decoColor} />
    </Container>
  );
};

export default SectionDeco;
